/**
 * Classe de grid paa a funcionalidade de monitoring orders.
 * @author: adalto.junior
 * Date: 19/10/13
 * Time: 15:14
 */


Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.LineItems = Greenmile.RouteSummary.LineItems || {};
Greenmile.RouteSummary.LineItems.Grid = (function () {

    function Grid () {

        Greenmile.RouteSummary.Grid.apply(this, arguments);

        this.entity = 'RouteSummaryLineItems';

        this.containerGrid = "#RouteSummary #allContent #lineItemsGrid #grid";
        this.gridActionsSelector = "#RouteSummary #allContent #lineItemsGrid .gridActions";
        this.entityToActionGrid = 'LineItem';
        this.countCustomColumns = 0;

    }

    return Grid;

}());
